import type { TrackingInfo } from '@/composables/useThirdLogin'

export const PROVIDER_TRACKING = {
  google: { loginType: 'Google', authMethod: 'google' },
  googleOneTap: { loginType: 'GoogleOneTap', authMethod: 'googleonetap' },
  apple: { loginType: 'Apple', authMethod: 'apple' },
  facebook: { loginType: 'FB', authMethod: 'facebook' },
} as const satisfies Record<string, TrackingInfo>
